import React, { useCallback } from "react";
import AuditTrailReport from "./AuditTrailReport";

const IndividualReport = ({
  currentReportType,
  reportData
}) => {
  const getReportSpecificComponent = useCallback(() => {
    switch (currentReportType) {
      case "auditTrail":
        return (
          <AuditTrailReport
            reportData={reportData}
          />
      );

      default:
        return null;
    }
  }, [currentReportType, reportData]);

  return (
    <>
        <tbody>{getReportSpecificComponent()}</tbody>
    </>
  );
};

export default IndividualReport;
